import { useAppSelector } from "@app/hooks"
import { CourseDto } from "@masterschool/course-builder-api"
import {
  selectActiveCourse,
  selectLastPublishedVersion,
} from "@features/courseEditor/courseEditorSelectors"
import StatusChip, { StatusChipProps } from "./statusChip"
import { courseStatusTextAndColor } from "./courseStatus+Ui"
import { selectIsEditingPublishedCourse } from "@features/coursesMenu/coursesSelectors"
import { areCourseDtosEqual } from "@utils/courseUtils"
import { parseStringVersion } from "@utils/versionUtils"

function CourseEditorStatus(props: { course: CourseDto }) {
  const { course } = props
  const { major } = parseStringVersion(course.version)
  const currentEditedCourseDto = useAppSelector(selectActiveCourse)
  const publishedCourse = useAppSelector(selectLastPublishedVersion)
  const isEditingPublishedCourse = useAppSelector(
    selectIsEditingPublishedCourse(course.id, major),
  )

  const hasChanges =
    currentEditedCourseDto !== undefined &&
    publishedCourse !== undefined &&
    !areCourseDtosEqual(publishedCourse, currentEditedCourseDto)

  const statusTextAndColor = isEditingPublishedCourse
    ? {
        text: "Published",
        color: "success" as const,
      }
    : courseStatusTextAndColor(course.status)

  return (
    <CourseStatus
      text={statusTextAndColor.text}
      color={statusTextAndColor.color}
      showIndicator={hasChanges}
    />
  )
}

function CourseStatus(props: Omit<StatusChipProps, "isActive">) {
  return <StatusChip {...props} isActive={undefined} />
}

export default CourseEditorStatus
